import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import AdCardMetric from '../../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric'
import { renderMetricValue } from '../../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric/renderMetricValue'
import { getCpaTitle } from '../../../../../../../features/components/ListItemsTable/Columns/ConversionResultsColumns/ResultsCell/helpers'

import {
  calculateCPA,
  parseStringToObject
} from '../../../../../../../features/components/ListItemsTable/Columns/ConversionResultsColumns/helpers'
import { formatCurrency } from '../../../../../../../helpers/numbers'

import { selectedPartnershipSelector } from '../../../../../../../modules/selectors/partnerships'

import useStyles from '../styles'

const ConversionRelatedMetrics = ({ formattedData, ad, currencySymbol }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const { advanced_metrics: isAdvancedMetricsPartnership } = useSelector(selectedPartnershipSelector)

  const { roas } = formattedData
  const { spend, results } = ad

  const parsedResults = parseStringToObject(results)
  const { name: conversionName, value: conversionValue } = parsedResults
  const calculatedCPA = calculateCPA(spend, conversionValue)

  const cpaTitle = getCpaTitle(conversionName)

  const showAdvancedConversionsMetrics = useMemo(
    () => conversionValue > 0 && isAdvancedMetricsPartnership,
    [conversionValue, isAdvancedMetricsPartnership]
  )

  if (conversionValue > 0) {
    return (
      <>
        <AdCardMetric>
          <div>{conversionName}</div>
          <div className={classes.conversionsWrapper}>
            <div>{conversionValue}</div>
            {
              <div className={classes.conversionsValue}>
                {cpaTitle}:{' '}
                {formatCurrency(
                  calculatedCPA,
                  { min: 2, max: 2 },
                  {
                    symbol: currencySymbol
                  }
                ) || '-'}
              </div>
            }
          </div>
        </AdCardMetric>
        {showAdvancedConversionsMetrics && (
          <AdCardMetric>
            <div>{t('ROAS')}</div>
            <div>{renderMetricValue(roas)}</div>
          </AdCardMetric>
        )}
      </>
    )
  }
  // todo PBR-1057 add if else for landing_page_view, currently request fails with this insight
  // If conversions, lead and complete_registration = 0 but landing_page_view > 0 then show a column called Landing Page Views
}

export default ConversionRelatedMetrics
